export const GENERAL_LEDGER_SOURCE_VALUE ={
     PAYMENT_RECEIPT : 1, 
     CASH_PAYMENT : 2,
     CHEQUE_PAYMENT : 3,
     CARD_PAYMENT : 4,
     BANK_PAYMENT : 5,
     RETURN_AMOUNT : 6,
     OVER_PAYMENT : 7,
     EXPENSE_AMOUNT : 8,
     PAYMENT_VOUCHER : 9,
     SUPPLIER_CASH_PAYMENT : 10,
     SUPPLIER_CHEQUE_PAYMENT : 11,
     SUPPLIER_CARD_PAYMENT : 12,
     SUPPLIER_BANK_PAYMENT : 13,
     PURCHASE_RETURN : 14,
     SALES_RETURN : 15,
     ACCOUNT_TRANSACTION : 16,
     CUSTOMER_CHEQUE_RETURN_CASH_PAYMENT : 17,
     CUSTOMER_CHEQUE_RETURN_CHEQUE_PAYMENT : 18,
     CUSTOMER_CHEQUE_RETURN_BANK_PAYMENT : 19,
     CUSTOMER_CHEQUE_RETURN_CARD_PAYMENT : 20,
     BROUGHT_FORWARD_CASH_BOOK : 21,
     BROUGHT_FORWARD_BANK : 22,
     BROUGHT_FORWARD_CREDIT_CARD : 23,
     ONLINE_TRANSFER_PAYMENT : 24,
     SUPPLIER_ONLINE_TRANSFER_PAYMENT : 25,
     CUSTOMER_CHEQUE_RETURN_ONLINE_PAYMENT : 26,
     EXPENSE_CASH_PAYMENT : 27,
     EXPENSE_CHEQUE_PAYMENT : 28,
     EXPENSE_CARD_PAYMENT : 29,
     EXPENSE_BANK_PAYMENT : 30,
     EXPENSE_ONLINE_PAYMENT : 31,
     CHEQUES_MOVE_TO_BANK_PAYMENT : 32,
     CHEQUE_PAYMENT_RETURNED : 33,
     CHEQUE_PAYMENT_REALIZED : 34,
     CHEQUE_IN_HAND : 35,
     SUPPLIER_CHEQUE_PAYMENT_REALIZED : 35,
     SUPPLIER_CHEQUE_PAYMENT_RETURNED : 37,
     CASH_CONYROLLER_BROUGHT_FORWARD : 38,
     CAPTAL_ACCOUNT_BROUGHT_FORWARD : 39,
     EXISTING_BROUGHT_FORWARD:40

}